import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
        <g>
            <path d="M10.752 5.345L10 6.097 8.194 7.903l-2.183 2.184-1.882 1.882c-.305.305-.616.605-.915.915l-.013.013.457-.189H.653l.646.646v-1.012-1.993l-.189.457.752-.752 1.806-1.806 2.183-2.184 1.882-1.882c.3-.305.616-.605.915-.915l.013-.013h-.913l1.021 1.022 1.614 1.614.371.371a.646.646 0 10.913-.914l-1.025-1.021-1.614-1.614-.371-.371a.656.656 0 00-.913 0l-.326.326-.86.86-1.22 1.22-1.391 1.392-1.389 1.39-1.207 1.207-.847.848-.232.232a.752.752 0 00-.266.533c-.01.42 0 .843 0 1.262v1.745a.655.655 0 00.646.646h2.903a1.5 1.5 0 00.189-.011.676.676 0 00.389-.2l.16-.16.734-.735 1.138-1.138 1.362-1.362 1.407-1.408 1.275-1.275.963-.964.473-.473.021-.021a.655.655 0 000-.914.662.662 0 00-.914.004z" fill={fill} />
        </g>
        <g>
            <path d="M12.73 3.37l-.668.668-1.06 1.061-.247.247h.913l-1.021-1.022L9.03 2.71l-.371-.371v.912l.679-.68 1.068-1.069a3.72 3.72 0 01.279-.273l-.131.1a.694.694 0 01.134-.079l-.155.065a.685.685 0 01.147-.04l-.171.023a.787.787 0 01.174 0l-.171-.023a.662.662 0 01.147.04l-.155-.065a.624.624 0 01.134.079l-.131-.1c.09.074.171.166.255.249l.524.525 1.191 1.191a4.127 4.127 0 01.3.307l-.1-.131a.648.648 0 01.079.137c-.021-.052-.044-.1-.065-.155a.684.684 0 01.039.15 11.569 11.569 0 01-.023-.171.716.716 0 010 .155l.023-.171a.692.692 0 01-.04.15c.021-.052.044-.1.065-.155a.7.7 0 01-.081.137l.1-.131a.787.787 0 01-.047.052.671.671 0 00-.189.457.646.646 0 001.1.457 1.27 1.27 0 00.32-1.2 1.254 1.254 0 00-.334-.567l-.379-.379L11.91.801l-.413-.413a1.26 1.26 0 00-.971-.387 1.24 1.24 0 00-.6.189 3.2 3.2 0 00-.452.41l-.625.625c-.363.363-.728.722-1.088 1.088l-.021.021a.656.656 0 000 .914L8.762 4.27l1.614 1.614.371.371a.656.656 0 00.913 0l.668-.668 1.06-1.061.247-.247a.644.644 0 10-.909-.912z" fill={fill} />
        </g>
    </svg>
);

EditIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

EditIcon.defaultProps = {
    width: '14',
    height: '14',
    fill: '#4b254e'
};

export default EditIcon;
